/**
 *
 * Instancia de axios pre configurado
 *
 */

import axios from "axios";
// import clientStorage from "./clientStorage";
import * as buildUrl from "axios/lib/helpers/buildURL";
import { secureStorage } from "./secureStorage.js";

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    "Access-Control-Allow-Origin": "*",
    Authorization: secureStorage.getItem("token")
  }
});

function getFromStorage(url = "", config = {}) {
  url = buildUrl(url, config.params);
  var stringValue = secureStorage.getItem(url);
  if (stringValue) {
    return new Promise((rsv) => {
      rsv(JSON.parse(stringValue));
    });

    // return new Promise((rsv) => {
    //   rsv({ data: JSON.parse(stringValue) });
    // });
  } else {
    return new Promise((rsv) => {
      http.get(url).then(({ data }) => {
        secureStorage.setItem(url, JSON.stringify(data));
        rsv(data);
      });
    });
  }
}

http.getFromStorage = getFromStorage;

// export const getFromLocalStorage = function(
//   url = "",
//   config = {},
//   getFromServer = false
// ) {
//   url = buildUrl(url, config.params);
//   var stringValue = secureStorage.getItem(url);
//   if (!getFromServer && stringValue) {
//     return new Promise(rsv => {
//       rsv({ data: JSON.parse(stringValue) });
//     });
//   } else {
//     return new Promise(rsv => {
//       http.get(url).then(res => {
//         secureStorage.setItem(url, JSON.stringify(res.data));
//         rsv(res);
//       });
//     });
//   }
// };

// export const getFromSessionStorage = function(
//   url = "",
//   config = {},
//   getFromServer = false
// ) {
//   url = buildUrl(url, config.params);
//   var stringValue = secureSessionStorage.getItem(url);
//   if (!getFromServer && stringValue) {
//     return new Promise(rsv => {
//       rsv({ data: JSON.parse(stringValue) });
//     });
//   } else {
//     return new Promise(rsv => {
//       http.get(url).then(res => {
//         secureSessionStorage.setItem(url, JSON.stringify(res.data));
//         rsv(res);
//       });
//     });
//   }
// };

export default http;
export { getFromStorage };
